<template>
    <div class="w-full">
        <div
            class="relative border-1 rounded-2xl min-w-full grid desktop:grid-cols-6 largeDesktop:grid-cols-5 desktop:gap-[15px] largeDesktop:gap-[30px] p-[20px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]"
>
            <div
id="accordionExample"
                class="col-span-5 desktop:col-span-3 largeDesktop:col-span-3 accordion rounded-0 flex flex-col gap-[15px]"
>
                <!-- STEP 1 -->
                <div
                    class="accordion-item border-0 p-[20px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px] first:!rounded-t-[10px]"
>
                    <button
class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-roboto font-medium text-[#333333]
              [&:not(.collapsed)]:!bg-transparent
              [&:not(.collapsed)]:!shadow-none
              [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button" @click="toggleAccordion(1)"
>
                        <p class="m-0">
                            <span class="text-[#BA90C6]">Step 1:</span> Service Details
                        </p>

                        <div v-if="openAccordion == 1" class="accordionIcon ">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt=""
>
                        </div>
                        <div
v-else-if="step1Completed"
                            class="accordionIcon transition-transform duration-300 w-[30px] h-[30px] flex items-center justify-center rounded-full hover:bg-[#EFEFEF]/50"
>
                            <img src="../../../assets/images/accordion-orange-edit-icon.svg" alt="">
                        </div>
                        <div v-else class="accordionIcon">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt=""
>
                        </div>
</button>

                    <div v-show="openAccordion == 1" class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <serviceDetail ref="serviceDetailRef" @submit-detail="handleStep1Complete" />
                        </div>
                    </div>
                </div>

                <!-- STEP 2 -->
                <div class="accordion-item border-0 p-[20px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px]">
                    <button
class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-roboto font-medium text-[#333333]
              [&:not(.collapsed)]:!bg-transparent
              [&:not(.collapsed)]:!shadow-none
              [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button"
                        :class="{ '!cursor-not-allowed': !step1Completed }" @click="toggleAccordion(2)"
>
                        <p class="m-0">
                            <span class="text-[#BA90C6]" :class="{ '!text-[#999]': !step1Completed }">Step 2:</span>
                            Billing Information
                        </p>

                        <div v-if="openAccordion == 2" class="accordionIcon ">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt=""
>
                        </div>
                        <div
v-else-if="step2Completed"
                            class="accordionIcon transition-transform duration-300 w-[30px] h-[30px] flex items-center justify-center rounded-full hover:bg-[#EFEFEF]/50"
>
                            <img src="../../../assets/images/accordion-orange-edit-icon.svg" alt="">
                        </div>
                        <div v-else class="accordionIcon">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt=""
>
                        </div>
                    </button>

                    <div v-show="openAccordion == 2 && step1Completed" class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <billingInformation ref="billingInformationRef" @submit-detail="handleStep2Complete" />
                        </div>
                    </div>
                </div>

                <!-- STEP 3 -->
                <div
                    class="accordion-item border-0 p-[20px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px] last:!rounded-b-[10px]"
>
                    <button
class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-roboto font-medium text-[#333333]
              [&:not(.collapsed)]:!bg-transparent
              [&:not(.collapsed)]:!shadow-none
              [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button"
                        :class="{ '!cursor-not-allowed': !step2Completed }" @click="toggleAccordion(3)"
>
                        <p class="m-0">
                            <span class="text-[#BA90C6]" :class="{ '!text-[#999]': !step2Completed }">Step 3:</span>
                            Payment Information
                        </p>
                        <div v-if="openAccordion == 3" class="accordionIcon ">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt=""
>
                        </div>
                        <div v-else class="accordionIcon">
                            <img
src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt=""
>
                        </div>
                    </button>

                    <div v-show="openAccordion == 3 && step2Completed" class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <paymentInformation
ref="paymentInformationRef" :stripe_id="stripId"
                                @submit-detail="handleStep3Complete"
/>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="mt-[40px] laptop:mt-0 col-span-5 desktop:col-span-3 largeDesktop:col-span-2 p-[20px] largeDesktop:p-[20px] rounded-[10px] shadow-[0px_4px_10px_0px_#0000001A]"
>
                <div class="relative flex flex-col items-baseline tablet:flex-row tablet:items-center tablet:justify-between gap-[10px]">
                    <div class="flex items-center gap-[5px] largeDesktop:gap-[10px]">
                        <div
class="flex items-center gap-2 rounded-full mobile:px-2 mobile:py-0.5 tablet:px-3 tablet:py-1 w-max bg-[#29C6CD]"
                            :class="{ '!bg-[#ccc]': modalCartCount == 0 }"
>
                            <img
src="../../../assets/images/cart-check-white.png" alt="Cart Icon"
                                class="mobile:w-7 mobile:h-7 tablet:w-5 tablet:h-5 largeDesktop:w-7 largeDesktop:h-7"
>
                            <span
                                class="mobile:text-lg desktop::text-[14px] largeDesktop::text-[20px] font-roboto font-bold text-white"
>{{
                                    modalCartCount
                                }}</span>
                        </div>
                        <div class="leading-[1]">
                            <h4
                                class="desktop:text-[20px] largeDesktop:text-[24px] m-0 font-roboto font-bold text-[#333333]"
>
                                Cart
</h4>
                            <p
                                class="desktop:text-[12px] largeDesktop:text-[14px] m-0 font-roboto font-normal text-[#666]"
>
                                Check your plans before checkout
</p>
                        </div>
                    </div>
                    <div
class="group cursor-pointer flex items-center justify-center mobile:mx-auto tablet:!mx-0 largeDesktop:gap-[5px] w-max tablet:w-auto rounded-full shadow-[0px_0px_10px_0px_#0000001A] p-[5px] pr-[10px] transition duration-300 bg-[#fff] hover:bg-[#14C38E] [@media(max-width:1023px)]:!bg-[#14C38E]"
                        @click="optionalCoverageClick"
>
                        <div
                            class="min-w-[25px] min-h-[25px] largeDesktop:min-w-[30px] largeDesktop:min-h-[30px] flex items-center justify-center rounded-full shadow-[0px_0px_10px_0px_#0000001A] border-[2px] border-[#fff] bg-[#14C38E] text-[#fff] "
>
                            <i class="fa fa-plus" />
                        </div>
                        <p
                            class="m-0 font-roboto desktop:text-[12px] largeDesktop:text-[16px] transition duration-300 text-[#000000]  group-hover:text-[#fff] [@media(max-width:1023px)]:!text-[#fff]"
>
                            Optional Coverages
</p>
                    </div>
                </div>
                <div
                    class="flex flex-col gap-[10px] desktop:max-h-[95vh] largeDesktop:max-h-[65vh] mt-4 laptop:pr-2 overflow-y-auto customScrollbar"
>
                    <bundleCartCard
v-for="(bundle, index) in cartDetails.bundles" :key="index" :bundle="bundle"
                        :update-cart="updateBundleCart" :update-card="updateCardCart"
/>
                    <cartCard
v-for="(plan, index) in cartDetails.items" :key="index" :plan="plan"
                        :update-cart="updateCart" :update-card="updateCardCart"
/>
                </div>
                <div class="mt-[15px] py-2 pr-2 text-right">
                    <h6 class="m-0 mobile:text-sm tablet:text-base font-roboto font-semibold text-[#BA90C6]">
                        Total Amount
</h6>
                    <h2 class="m-0 mobile:text-xl tablet:text-3xl font-roboto font-bold  text-gray-950">
${{
                        $helper.formatAmount(cartItemsTotal) }}/mo
                    </h2>
                </div>
            </div>
        </div>
    </div>

    <!-- Addons Modal -->
    <addonsModal ref="addonsModalRef" :disable-watcher="true" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import serviceDetail from '../../../components/nest_components/partner-checkout/service_detail.vue';
import billingInformation from '../../../components/nest_components/partner-checkout/billing-information.vue';
import paymentInformation from '../../../components/nest_components/partner-checkout/payment-information.vue';
import cartCard from '../../../components/partnerCartCard/cartCard.vue';
import bundleCartCard from '../../../components/partnerCartCard/bundleCartCard.vue';
import addonsModal from '../../../components/nest_components/addons/addons_modal.vue';

export default {
    components: {
        serviceDetail,
        billingInformation,
        paymentInformation,
        cartCard,
        bundleCartCard,
        addonsModal
    },
    data() {
        return {
            openAccordion: 1, // Start with Step 1 open
            step1Completed: false,
            step2Completed: false,
            dataForm: {},
            stripId: null,
            updateCard: null,
            updateCardCart: null,
            selectedPlan: {},
            selectedType: 'bundle',
            isCartUpdate: false,
        };
    },
    computed: {
        ...mapGetters([
            "cartDetails", "userAccountDetails", "cartValidate", "removeProtectionCartData", "cartUpdated", "uploadMediaResponse", "internalCheckoutResponse"
        ]),
        cartItemsTotal() {
            let total = 0
            if (this.cartDetails?.items?.length > 0) {
                total = this.cartDetails.items.reduce((sum, item) => sum + parseFloat(item.item_total_amount), 0);
            }
            if (this.cartDetails?.bundles?.length > 0) {
                total = total + this.cartDetails?.bundles?.reduce((sum, item) => sum + parseFloat(item.bundle_amount), 0);
            }
            return total
        },
        modalCartCount() {
            let totalQuantity = 0
            if (this.cartDetails?.items?.length > 0) {

                totalQuantity = totalQuantity + this.cartDetails?.items?.length;
            }
            if (this.cartDetails?.bundles?.length > 0) {

                // totalQuantity = totalQuantity + this.cartDetails?.bundles?.reduce((sum, bundle) => sum + bundle.items.length, 0)
                totalQuantity = totalQuantity + this.cartDetails?.bundles?.length;

            }
            return totalQuantity
        },

    },


    watch: {
        userAccountDetails: function () {
            this.stripId = this.userAccountDetails.stripe_id
        },

        removeProtectionCartData: function (data) {

            if (this.selectedType == 'bundle') {
                this.upsertCart({
                    "bundle_id": this.selectedPlan.id,
                    "quantity": this.selectedPlan.quantity,
                    "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                })
            }
            else {
                this.upsertCart({
                    "plan_id": this.selectedPlan.id,
                    "quantity": this.selectedPlan.quantity,
                    "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                })
            }

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                if (this.selectedType == 'bundle') {
                    this.upsertCart({
                        "bundle_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }

            }
            else {
                this.$confirmDialog.show({
                    title: "Action Required",
                    message: this.cartValidate.message,

                    onConfirm: () => {
                        this.removeBundle(this.cartValidate)
                    },
                });
            }

        },
        cartUpdated: function (data) {
            this.getCartDetails({})
        },

        uploadMediaResponse: function (data) {
            this.dataForm['signature_image'] = this.uploadMediaResponse.file_name
            this.performCheckout()
        },

        internalCheckoutResponse: function (data) {
            if (!this.$helper.isEmpty(this.internalCheckoutResponse?.order_number)) {
                this.$router.replace({
                    name: 'thankyou',
                    query: {
                        order_id: this.internalCheckoutResponse?.order_number
                    }
                })
            }
        },
    },

    mounted() {
        this.getUserAccountDetails({})
        this.getCartDetails({})
    },
    methods: {
        ...mapActions([
            "getCartDetails",
            "getCartCount",
            "getUserAccountDetails",
            "upsertCart",
            "validateCart",
            "removeProtectionItemCart",
            "uploadMedia",
            "internalCheckout"
        ]),

        toggleAccordion(step) {
            // prevent next step until Step 1 complete
            if ((step === 2 || step === 3) && !this.step1Completed) return;
            this.openAccordion = this.openAccordion === step ? null : step;
            this.$nextTick(() => {
                if (step == '1' && this.step1Completed) {
                    this.openAccordion = 1 // Start with Step 1 open
                    this.step1Completed = false
                    this.step2Completed = false
                    this.$refs.serviceDetailRef?.setData(this.dataForm)
                } else if (step == '2' && this.step2Completed) {
                    this.$refs.billingInformationRef?.setData(this.dataForm)
                } else if (step == '3') {

                }
            })

        },
        handleStep1Complete(data) {
            this.dataForm = {}
            this.dataForm = data; // store it if needed later
            this.step1Completed = true;
            this.openAccordion = 2; // auto-open Step 2 after success
            this.$refs.billingInformationRef?.reset()
        },

        handleStep2Complete(data) {
            this.dataForm['is_billing_address_same'] = data.is_billing_address_same;
            if (data.is_billing_address_same == '0')
                this.dataForm['billing_address'] = data.billing_address; // store it if needed later
            this.step2Completed = true;
            this.openAccordion = 3; // auto-open Step 2 after success
            this.$refs.paymentInformationRef?.reset()
        },

        handleStep3Complete(data) {
            this.dataForm['card_token'] = data.card_token;
            this.dataForm['card_holder_name'] = data.card_holder_name; // store it if needed later
            let formData = new FormData();
            formData.append("file", data.signature_image);
            formData.append("upload_type", "signature");

            this.$dialog.show({
                title: "Confirm Checkout",
                text: "Are you sure you want to move forward with checkout?",
                onConfirm: () => {
                    this.uploadMedia(formData)
                },
            });
        },

        updateBundleCart(option, plan) {
            this.updateCartCall(option, plan, 'bundle', 'update')

        },
        updateCart(option, plan, type) {
            if (type == 'plan') {
                this.updateCartCall(option, plan, 'plan', '')
            }
            else {
                this.updateCartCall(option, plan, 'bundle', 'update')
            }
        },

        updateCartCall(option, plan, type = 'bundle', action = 'update') {

            this.selectedPlan = plan
            this.selectedType = type
            if (option == "cartUpdate") {
                this.isCartUpdate = true
            } else {
                this.isCartUpdate = false
            }

            if (option == 'decrement' || option == 'remove') {

                if (type == 'bundle') {
                    this.upsertCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }

            }
            else {

                if (type == 'bundle') {
                    this.validateCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }
                else {
                    this.validateCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }
            }

        },

        performCheckout() {
            this.internalCheckout(this.dataForm)
        },

        removeBundle(data) {
            this.removeProtectionItemCart({
                "bundle_ids": data.bundle_ids,
                "plan_ids": data.plan_ids,
            })
        },

        optionalCoverageClick() {
            this.$refs.addonsModalRef.openModal();
        }
    },
};
</script>
